import type { NavLink } from '@myTypes';

export const SITE_CONFIG = {
  name: 'The CISO Network',
  tagline: 'Fractional CISO services for growing businesses',
  description:
    "The UK's #1 Network of Fractional CISOs, ready to help your business leaders build a top-tier, robust cybersecurity program.",
  url: 'https://thecisonetwork.com',
  email: 'contact@thecisonetwork.com',
  social: {
    linkedin: 'https://linkedin.com/company/thecisonetwork',
    twitter: 'https://x.com/thecisonetwork',
    github: 'https://github.com/thecisonetwork',
  },
} as const;

export const NAV_LINKS: NavLink[] = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'FAQ', href: '#faq' },
] as const;

export const CALENDLY_URL = 'https://calendly.com/chris-thecisonetwork/30min' as const;

export const META = {
  title: `${SITE_CONFIG.name}`,
  description: SITE_CONFIG.description,
  keywords: [
    'fractional CISO',
    'virtual CISO',
    'vCISO',
    'cybersecurity',
    'information security',
    'security consulting',
    'data protection',
    'compliance',
    'risk management',
    'security leadership',
  ].join(', '),
} as const;
